'use strict';

var FlowMixChartDirective = function FlowMixChartDirective(Chart) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/flow-mix-chart.html'),
    controller: 'FlowMixChartController',
    scope: {
      screenState: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      scope.renderChartDataPresent = function (data) {
        chart.withMetric(scope.selectedMetric).render(data);
      };
      scope.$on('brush-filter:filterApplied', scope.onBrushFilterApplied);
      scope.$on('search-criteria:searchChangeEvent', scope.reloadChart);

      //hack for sly to make inner content scrollable. Remove when it will be fixed in Sly
      element.on('mousedown', '.rm-chart-scroll-wrapper', function (event) {
        event.stopPropagation();
      });
      scope.$on(scope.screen + ':scenariosChanged', scope.reloadChart);
      scope.$watch('screenState.dataRepresentation', function (dataRepresentation) {
        if (dataRepresentation) {
          scope.onDataRepresentationChange(dataRepresentation);
        }
      });
    }
  };
};
FlowMixChartDirective.$inject = ['FlowMixChart'];
module.exports = FlowMixChartDirective;